import { render, staticRenderFns } from "./VerifiedConfigExtra.vue?vue&type=template&id=270e717a"
import script from "./VerifiedConfigExtra.vue?vue&type=script&lang=js"
export * from "./VerifiedConfigExtra.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports